import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('segmented-toggle', {
  root: {
    variants: {
      size: ['tiny', 'small', 'medium'],
    },
    states: ['disabled', 'fullWidth'],
  },
  item: {
    variants: {
      size: ['tiny', 'small', 'medium'],
    },
    states: ['selected'],
  },
  divider: {
    states: ['disabled', 'transparent'],
  },
});
